import { render, staticRenderFns } from "./DataAnalyzer.vue?vue&type=template&id=0ec56af8"
import script from "./DataAnalyzer.vue?vue&type=script&lang=js"
export * from "./DataAnalyzer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports